import React from 'react';
import { useSelector } from 'react-redux';
import { assocPath, mergeDeepRight, propOr } from '../utils/fp';
import { innerPalette, sisccTheme } from '@sis-cc/dotstatsuite-visions/theme';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { getIsRtl, getHasAccessibility } from '../selectors/router';
import { Rtl } from './jss-provider';

const excel = {
  headerFont: '#ffffff',
  sectionFont: '#000000',
  rowFont: '#000000',
};

// Accessibility mode repaints the focus ring with the highlight colour. It rides
// on CssBaseline, which the app renders inside this provider.
const a11yFocus = outerPalette => ({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':focus': {
          outlineColor: `${outerPalette.highlight1 || innerPalette.highlight1} !important`,
        },
      },
    },
  },
});

const Provider = ({ theme, children }) => {
  const isRtl = useSelector(getIsRtl);
  const isA11y = useSelector(getHasAccessibility);

  const base = sisccTheme({
    rtl: isRtl ? 'rtl' : 'ltr',
    isA11y,
    outerPalette: theme.outerPalette,
  });
  const composed = assocPath(['mixins', 'excel'], excel, mergeDeepRight(base, theme));
  const muiTheme = createTheme(
    isA11y ? mergeDeepRight(composed, a11yFocus(propOr({}, 'outerPalette', theme))) : composed,
  );

  return (
    <Rtl>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
      </StyledEngineProvider>
    </Rtl>
  );
};

export default Provider;
